const STORAGE_KEY = 'mcc_geo_v1';
const TTL_MS = 30 * 60 * 1000;

export const getCachedCoords = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.lat !== 'number' || typeof parsed.lng !== 'number' || typeof parsed.ts !== 'number') return null;
    if (Date.now() - parsed.ts > TTL_MS) return null;
    return { lat: parsed.lat, lng: parsed.lng };
  } catch {
    return null;
  }
};

export const setCachedCoords = ({ lat, lng }) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng, ts: Date.now() }));
  } catch {
    // ignore
  }
};

export const requestCoords = ({ timeoutMs = 9000, maximumAgeMs = 60_000 } = {}) =>
  new Promise((resolve, reject) => {
    const cached = getCachedCoords();
    if (cached) return resolve({ ...cached, source: 'cache' });

    if (!navigator.geolocation) {
      return reject({ code: 'UNSUPPORTED', message: 'Geolocation is not supported by your browser.' });
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setCachedCoords(coords);
        resolve({ ...coords, source: 'geolocation' });
      },
      (err) => reject({ code: err.code, message: err.message || 'Unable to access your location.' }),
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: maximumAgeMs }
    );
  });

